define('collections/pixelsInContainer',["jQuery", "T1", "T1Collection", "models/pixelInContainer"], function ($, T1, T1Collection, PixelInContainer) {
  T1.Models.PixelsInContainer = T1Collection.extend({
    model: PixelInContainer,
    urlString: "pixels"
  });
  return T1.Models.PixelsInContainer;
});
